// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__2EVyG","circle":"styles_circle__4w0Hx","spin":"styles_spin__2fgei"};